import './scss/index.scss';
import { dcFactory } from 'dc';
import RegionSelectorComponent from './js/region-selector.component';

dcFactory.register(RegionSelectorComponent);
